/* import __COLOCATED_TEMPLATE__ from './brand-picker-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();